import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  generate() {
    const passwordField = document.getElementById("password-field")
    if (passwordField) {
      // Generate a random 10-digit number
      const randomPassword = Math.floor(1000000000 + Math.random() * 9000000000).toString()
      passwordField.value = randomPassword
    }
  }
}
